import React, { FunctionComponent } from 'react';
import { DataCategory, DataValueCompanyPageTvs } from '../../../types/companyDetail';

type Props = {
  id: number;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageTvs;
  updatedAt: string;
  image: string | null;
  tvTitle: string;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  dataCategory,
  dataValue,
  updatedAt,
  image,
  tvTitle,
}) => {
  return (
    <a
      href={`/tvs/${id}`}
      target="_blank"
      className="company__page__recruitments__wrapper__item gtm-movie-view-count"
      data-event-name='movie on screen'
      data-event="click"
      data-category={dataCategory}
      data-value={dataValue.selfMovie}
      rel="noreferrer"
    >
      <div className="company__page__recruitments__wrapper__item--cover">
        {image && <img src={image} alt={`${tvTitle || '動画'} のサムネイル`} />}
      </div>
      <div className="company__page__recruitments__wrapper__item__box">
        <p className="company__page__recruitments__wrapper__item__box--title">
          {tvTitle}
        </p>
        <p className="company__page__recruitments__wrapper__item__box--occupation">
          {updatedAt}
        </p>
      </div>
    </a>
  );
};
